(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-account"]) return;
  try {
    
function initializeWeirdoughReorder(button){
  if(button.dataset.reorderReady==='true')return;button.dataset.reorderReady='true';
  button.addEventListener('click',function(){
    var original=button.textContent;button.disabled=true;button.textContent='Adding bakes…';
    var items=[];
    try{items=JSON.parse(button.dataset.items);}catch(error){items=[];}
    if(!items.length){button.textContent='Nothing available';return;}
    fetch(button.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:items})})
      .then(function(response){if(!response.ok)throw new Error('Unavailable');return response.json();})
      .then(function(){window.location.href=button.dataset.cartUrl;})
      .catch(function(){button.disabled=false;button.textContent='Some bakes are unavailable';setTimeout(function(){button.textContent=original;},2600);});
  });
}
document.querySelectorAll('[data-wd-reorder]').forEach(initializeWeirdoughReorder);
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-wd-reorder]').forEach(initializeWeirdoughReorder);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const initializeStickyBasket = (sticky) => {
      if (!sticky || sticky.dataset.wdReady === 'true') return;
      const root = document.getElementById('MainProduct-' + sticky.dataset.sectionId);
      const proxy = sticky.querySelector('[data-wd-global-sticky-submit]');
      const proxyLabel = proxy?.querySelector('span');
      const price = sticky.querySelector('[data-wd-global-sticky-price]');
      const priceRoot = document.getElementById(sticky.dataset.priceTarget);
      if (!root || !proxy) return;

      sticky.dataset.wdReady = 'true';
      let original = null;
      let intersectionObserver = null;

      const setVisible = (visible) => {
        sticky.toggleAttribute('data-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        proxy.tabIndex = visible ? 0 : -1;
      };

      const sync = () => {
        if (!original) {
          setVisible(false);
          return;
        }
        proxy.disabled = original.disabled;
        proxy.setAttribute('aria-disabled', proxy.disabled ? 'true' : 'false');
        const originalLabel = original.querySelector(':scope > span')?.textContent.trim() || 'Add to basket';
        if (proxyLabel && proxyLabel.textContent.trim() !== originalLabel) proxyLabel.textContent = originalLabel;

        const priceBox = priceRoot?.querySelector('.price');
        const priceSelector = priceBox?.classList.contains('price--on-sale')
          ? '.price-item--sale'
          : '.price-item--regular';
        const currentPrice = priceBox?.querySelector(priceSelector);
        if (price && currentPrice?.textContent.trim()) price.textContent = currentPrice.textContent.trim();
      };

      const observeOriginal = () => {
        const next = root.querySelector('form[data-type="add-to-cart-form"] .product-form__submit');
        if (next === original) {
          sync();
          return;
        }
        intersectionObserver?.disconnect();
        original = next;
        setVisible(false);
        if (!original) return;

        if ('IntersectionObserver' in window) {
          intersectionObserver = new IntersectionObserver(([entry]) => {
            setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
          }, { threshold: 0 });
          intersectionObserver.observe(original);
        } else {
          const assess = () => setVisible(original && original.getBoundingClientRect().bottom < 0);
          window.addEventListener('scroll', assess, { passive: true });
          assess();
        }
        sync();
      };

      new MutationObserver(observeOriginal).observe(root, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true
      });

      root.addEventListener('change', () => window.setTimeout(observeOriginal, 0));
      proxy.addEventListener('click', () => {
        observeOriginal();
        if (original && !proxy.disabled) original.click();
      });
      observeOriginal();
    };

    const boot = (root = document) => {
      root.querySelectorAll('[data-wd-global-sticky]').forEach(initializeStickyBasket);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => boot());
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-bake-finder"] && !Shopify.designMode) return;
  try {
    
function initializeWeirdoughFinder(root){
  if(!root||root.dataset.finderReady==='true')return;
  root.dataset.finderReady='true';
  var values={delivery:'',moment:'',preference:''};
  var bars=Array.from(root.querySelectorAll('.wd-bake-finder__progress span'));
  var result=root.querySelector('[data-finder-result]');
  var title=root.querySelector('[data-finder-result-title]');
  var link=root.querySelector('[data-finder-result-link]');
  var routes={
    bread:'/collections/sourdough-breads',
    sweet:'/collections/sourdough-tea-cakes-scones-and-cookies',
    savoury:'/collections/sourdough-pizzas-and-flatbreads',
    celebration:'/collections/sourdough-tea-cakes-scones-and-cookies',
    gift:'/collections/frontpage',
    plan:'/collections/subscription',
    india:'/collections/sourdough-breads-biscotti-crackers-pan-india-delivery'
  };
  function refresh(){
    ['delivery','moment','preference'].forEach(function(key,index){bars[index].classList.toggle('is-complete',Boolean(values[key]));});
    if(!values.delivery||!values.moment||!values.preference){result.hidden=true;return;}
    var key=values.delivery==='india'?'india':values.moment==='gift'?'gift':values.moment==='plan'?'plan':values.moment==='celebration'?'celebration':values.preference;
    title.textContent=root.dataset['result'+key.charAt(0).toUpperCase()+key.slice(1)];
    link.href=routes[key];
    result.hidden=false;
    result.scrollIntoView({behavior:'smooth',block:'nearest'});
  }
  root.querySelectorAll('input[type="radio"]').forEach(function(input){
    input.addEventListener('change',function(){values[input.closest('fieldset').dataset.finderStep]=input.value;refresh();});
  });
  root.querySelector('[data-finder-reset]').addEventListener('click',function(){
    values={delivery:'',moment:'',preference:''};root.querySelectorAll('input[type="radio"]').forEach(function(input){input.checked=false;});refresh();
  });
}
document.querySelectorAll('[data-wd-bake-finder]').forEach(initializeWeirdoughFinder);
document.addEventListener('shopify:section:load',function(event){event.target.querySelectorAll('[data-wd-bake-finder]').forEach(initializeWeirdoughFinder);});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-hamper-product"]) return;
  try {
    
  (() => {
    const initHamperBuilder = (builder) => {
      if (!builder || builder.dataset.wdReady === 'true') return;
      const form = builder.closest('form');
      const variant = form?.querySelector('.product-variant-id');
      const extras = [...builder.querySelectorAll('[data-wd-builder-extra]')];
      const core = [...builder.querySelectorAll('[data-wd-builder-required]')];
      const status = builder.querySelector('[data-wd-builder-status]');
      const error = builder.querySelector('[data-wd-builder-error]');
      const price = form?.closest('.wd-hamper__buy-panel')?.querySelector('.wd-hamper__price');
      if (!form || !variant) return;
      builder.dataset.wdReady = 'true';
      const sync = () => {
        const selected = variant.options?.[variant.selectedIndex];
        const title = selected?.textContent || '';
        const extraCount = /for 6/i.test(title) ? 2 : (/for 4/i.test(title) ? 1 : 0);
        extras.forEach((label, index) => {
          const select = label.querySelector('select');
          const active = index < extraCount;
          label.hidden = !active;
          select.disabled = !active;
          select.required = active;
          if (!active) select.value = '';
        });
        core.forEach((select) => { select.required = true; });
        if (status) status.textContent = (4 + extraCount) + ' choices are required for this size.';
        if (price && selected?.dataset.wdVariantPrice) price.textContent = selected.dataset.wdVariantPrice;
        if (error) error.hidden = true;
      };
      form.addEventListener('submit', (event) => {
        const required = [...core, ...extras.map((label) => label.querySelector('select')).filter((select) => !select.disabled)];
        const missing = required.find((select) => !select.value);
        if (!missing) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (error) error.hidden = false;
        missing.focus();
      }, true);
      variant.addEventListener('change', sync);
      builder.querySelectorAll('select').forEach((select) => select.addEventListener('change', () => { if (error) error.hidden = true; }));
      sync();
    };
    const initStickyHamperBasket = (sticky) => {
      if (!sticky || sticky.dataset.wdReady === 'true') return;
      const hamper = sticky.previousElementSibling;
      const original = hamper?.querySelector('.wd-hamper-form__submit');
      const proxy = sticky.querySelector('[data-wd-hamper-sticky-submit]');
      if (!original || !proxy) return;
      sticky.dataset.wdReady = 'true';
      const proxyLabel = proxy.querySelector('span');
      const originalLabel = () => original.querySelector('span')?.textContent.trim() || 'Add to basket';
      const sync = () => {
        proxy.disabled = original.disabled;
        proxy.setAttribute('aria-disabled', proxy.disabled ? 'true' : 'false');
        if (proxyLabel && proxyLabel.textContent.trim() !== originalLabel()) proxyLabel.textContent = originalLabel();
      };
      const setVisible = (visible) => {
        sticky.toggleAttribute('data-visible', visible);
        sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
        proxy.tabIndex = visible ? 0 : -1;
      };
      const assess = () => {
        const rect = original.getBoundingClientRect();
        setVisible(rect.bottom < 0);
      };
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          setVisible(!entry.isIntersecting && entry.boundingClientRect.bottom < 0);
        }, { threshold: 0 });
        observer.observe(original);
      } else {
        window.addEventListener('scroll', assess, { passive: true });
        assess();
      }
      new MutationObserver(sync).observe(original, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true });
      proxy.addEventListener('click', () => {
        sync();
        if (!proxy.disabled) original.click();
      });
      sync();
    };
    const boot = (root = document) => {
      root.querySelectorAll('[data-wd-hamper-builder]').forEach(initHamperBuilder);
      root.querySelectorAll('[data-wd-hamper-sticky]').forEach(initStickyHamperBasket);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (event) => boot(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__weirdoughMenuDismissReady) return;
    window.__weirdoughMenuDismissReady = true;

    const closeMenusExcept = (target) => {
      document.querySelectorAll('.wd-mobile-menu[open], .wd-nav-dropdown[open]').forEach((menu) => {
        if (!menu.contains(target)) menu.removeAttribute('open');
      });
    };

    document.addEventListener('pointerdown', (event) => closeMenusExcept(event.target));
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.wd-mobile-menu[open], .wd-nav-dropdown[open]').forEach((menu) => menu.removeAttribute('open'));
    });
  })();

  (() => {
    if (window.__weirdoughCartDrawerDelegated) return;
    window.__weirdoughCartDrawerDelegated = true;

    const openWeirdoughCart = (trigger) => {
      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return false;

      if (typeof drawer.open === 'function') {
        drawer.open(trigger);
      } else {
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
      return true;
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-wd-cart-trigger]');
      if (!trigger) return;
      if (openWeirdoughCart(trigger)) event.preventDefault();
    }, true);

    document.addEventListener('keydown', (event) => {
      const trigger = event.target.closest('[data-wd-cart-trigger]');
      if (!trigger || event.code.toUpperCase() !== 'SPACE') return;
      if (openWeirdoughCart(trigger)) event.preventDefault();
    });
  })();

  (() => {
    if (window.__weirdoughDeliveryModeReady) return;
    window.__weirdoughDeliveryModeReady = true;
    const panIndiaCollection = '/collections/sourdough-breads-biscotti-crackers-pan-india-delivery';
    const mumbaiCollection = '/collections/sourdough-breads';
    const storageKey = 'weirdoughDeliveryMode';

    const readMode = () => {
      try { return localStorage.getItem(storageKey) === 'pan-india' ? 'pan-india' : 'mumbai'; }
      catch (error) { return 'mumbai'; }
    };
    const storeMode = (mode) => {
      try { localStorage.setItem(storageKey, mode); } catch (error) {}
    };
    const cardContainer = (card) => card.matches('article') ? card : (card.closest('li') || card);

    const applyMode = (mode) => {
      document.documentElement.dataset.wdActiveDeliveryMode = mode;
      document.querySelectorAll('[data-wd-delivery-mode]').forEach((button) => {
        button.setAttribute('aria-pressed', button.dataset.wdDeliveryMode === mode ? 'true' : 'false');
      });
      document.querySelectorAll('[data-wd-product-mode]').forEach((card) => {
        const show = card.dataset.wdProductMode === mode;
        const container = cardContainer(card);
        container.toggleAttribute('data-wd-mode-hidden', !show);
        container.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
      document.querySelectorAll('[data-wd-mode-link]').forEach((link) => {
        const next = mode === 'pan-india' ? link.dataset.wdPanIndiaHref : link.dataset.wdMumbaiHref;
        if (next) link.href = next;
      });
      document.querySelectorAll('[data-wd-mumbai-only-link]').forEach((link) => {
        const hidden = mode === 'pan-india';
        link.toggleAttribute('data-wd-mode-hidden', hidden);
        link.setAttribute('aria-hidden', hidden ? 'true' : 'false');
      });
      document.querySelectorAll('[data-wd-mumbai-only-action]').forEach((action) => {
        const blocked = mode === 'pan-india';
        const unavailable = action.dataset.wdUnavailable === 'true';
        action.disabled = blocked || unavailable;
        action.setAttribute('aria-disabled', action.disabled ? 'true' : 'false');
        const label = action.querySelector('span');
        if (label) {
          if (!label.dataset.wdOriginalLabel) label.dataset.wdOriginalLabel = label.textContent.trim();
          const nextLabel = blocked ? 'Available in Mumbai only' : label.dataset.wdOriginalLabel;
          if (label.textContent.trim() !== nextLabel) label.textContent = nextLabel;
        }
      });

      const path = window.location.pathname;
      const isProduct = path.indexOf('/products/') === 0;
      const isPanProduct = path.indexOf('pan-india') !== -1 || document.querySelector('[data-wd-current-product-mode="pan-india"]');
      let notice = document.querySelector('[data-wd-mode-notice]');
      if (mode === 'pan-india' && isProduct && !isPanProduct) {
        if (!notice) {
          const header = document.querySelector('[data-wd-header]');
          notice = document.createElement('div');
          notice.className = 'wd-mode-notice page-width';
          notice.dataset.wdModeNotice = '';
          const message = document.createElement('span');
          message.textContent = header?.dataset.wdMumbaiOnlyMessage || '';
          const button = document.createElement('button');
          button.type = 'button';
          button.dataset.wdSwitchMumbai = '';
          button.textContent = header?.dataset.wdSwitchMumbaiLabel || 'Switch to Mumbai';
          notice.append(message, button);
          document.querySelector('main')?.prepend(notice);
        }
      } else if (notice) notice.remove();
    };

    const selectMode = (mode, navigate) => {
      storeMode(mode);
      applyMode(mode);
      if (!navigate) return;
      const path = window.location.pathname;
      const keepsOwnExperience = path === '/collections/subscription' || path === '/collections/frontpage' || path === '/collections/jars-pantry' || path === '/collections/bundles';
      if (path.indexOf('/collections/') === 0 && !keepsOwnExperience) {
        if (mode === 'pan-india' && path !== panIndiaCollection) window.location.assign(panIndiaCollection);
        if (mode === 'mumbai' && path === panIndiaCollection) window.location.assign(mumbaiCollection);
      }
    };

    document.addEventListener('click', (event) => {
      const modeButton = event.target.closest('[data-wd-delivery-mode]');
      if (modeButton) selectMode(modeButton.dataset.wdDeliveryMode, true);
      const mumbaiButton = event.target.closest('[data-wd-switch-mumbai]');
      if (mumbaiButton) selectMode('mumbai', false);
    });
    document.addEventListener('shopify:section:load', () => applyMode(readMode()));
    new MutationObserver(() => applyMode(readMode())).observe(document.body, { childList: true, subtree: true });
    selectMode(readMode(), true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-home-search"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 749px)');

    document.querySelectorAll('.wd-home-search').forEach((search) => {
      const searchSection = search.closest('.shopify-section');
      const parent = searchSection?.parentElement;
      const heroSection = searchSection?.previousElementSibling;
      const followingSection = searchSection?.nextElementSibling;

      if (!searchSection || !parent || !heroSection || !followingSection) return;

      const placeSearch = () => {
        if (mobile.matches) {
          parent.insertBefore(searchSection, heroSection);
        } else {
          parent.insertBefore(searchSection, followingSection);
        }
      };

      placeSearch();
      mobile.addEventListener?.('change', placeSearch);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-wd-product-experience]');
    if (!section) return;
    const cleanTitle = section.dataset.displayTitle;
    const productTitle = document.querySelector('.product__title h1');
    if (section.dataset.eggStatus || section.dataset.preorder === 'true') {
      const media = document.querySelector('.product__media-wrapper');
      if (media && !media.querySelector('.wd-product-media-flags')) {
        const flags = document.createElement('div');
        flags.className = 'wd-product-media-flags';
        if (section.dataset.eggStatus) {
          const eggBadge = document.createElement('span');
          eggBadge.className = 'wd-product-media-flag';
          eggBadge.textContent = section.dataset.eggStatus;
          flags.appendChild(eggBadge);
        }
        if (section.dataset.preorder === 'true') {
          const preorderBadge = document.createElement('span');
          preorderBadge.className = 'wd-product-media-flag wd-product-media-flag--preorder';
          preorderBadge.textContent = 'Pre-order · 48 hrs';
          flags.appendChild(preorderBadge);
        }
        media.prepend(flags);
      }
    }
    if (productTitle && cleanTitle) productTitle.textContent = cleanTitle;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-product-trust"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.querySelector('[data-wd-pdp-trust]');
    if (!section) return;
    const sticky = section.querySelector('[data-wd-sticky]');
    const add = section.querySelector('[data-wd-add]');
    const productButton = document.querySelector('product-form button[type="submit"], [id^="ProductSubmitButton"]');
    if (!sticky || !productButton) return;
    sticky.hidden = false;
    add?.addEventListener('click', () => productButton.click());
    const observer = new IntersectionObserver(([entry]) => sticky.classList.toggle('is-hidden', entry.isIntersecting), { threshold: .1 });
    observer.observe(productButton);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-sourdough-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    document.querySelectorAll('[data-wd-crumb-intro]').forEach((intro) => {
      let ticking = false;

      const render = () => {
        ticking = false;
        if (reducedMotion.matches) return;

        const rect = intro.getBoundingClientRect();
        const travel = Math.max(intro.offsetHeight - window.innerHeight, 1);
        const progress = clamp(-rect.top / travel, 0, 1);
        const sliceFade = 1 - clamp((progress - .4) / .25, 0, 1);
        const crumbReveal = clamp((progress - .32) / .28, 0, 1);
        const openingFade = 1 - clamp(progress / .28, 0, 1);
        const closingReveal = clamp((progress - .76) / .16, 0, 1) * (1 - clamp((progress - .96) / .04, 0, 1));

        intro.style.setProperty('--wd-intro-progress', progress.toFixed(4));
        intro.style.setProperty('--wd-controls-offset', `${Math.max(rect.top, 0).toFixed(2)}px`);
        intro.style.setProperty('--wd-preview-bar-offset', document.querySelector('iframe[src*="/preview-bar/"]') ? '76px' : '0px');
        intro.style.setProperty('--wd-slice-scale', (1 + progress * 5.4).toFixed(4));
        intro.style.setProperty('--wd-slice-opacity', sliceFade.toFixed(4));
        intro.style.setProperty('--wd-crumb-scale', (1 + Math.max(progress - .32, 0) * 2.8).toFixed(4));
        intro.style.setProperty('--wd-crumb-opacity', crumbReveal.toFixed(4));
        intro.style.setProperty('--wd-opening-opacity', openingFade.toFixed(4));
        intro.style.setProperty('--wd-closing-opacity', closingReveal.toFixed(4));
      };

      const requestRender = () => {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(render);
      };

      intro.querySelector('[data-wd-intro-skip]')?.addEventListener('click', () => {
        const sectionWrapper = intro.closest('.shopify-section');
        const nextSection = sectionWrapper?.nextElementSibling || intro.nextElementSibling;
        if (!nextSection) return;
        nextSection.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
      });

      window.addEventListener('scroll', requestRender, { passive: true });
      window.addEventListener('resize', requestRender, { passive: true });
      reducedMotion.addEventListener?.('change', requestRender);
      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wd-subscription-unified"] && !Shopify.designMode) return;
  try {
    
function initializeWeirdoughSubscription(root) {
  if (!root || root.dataset.subscriptionReady === 'true') return;
  root.dataset.subscriptionReady = 'true';

  var planButtons = Array.from(root.querySelectorAll('[data-plan-option]'));
  var slots = Array.from(root.querySelectorAll('[data-delivery-slot]'));
  var variantInput = root.querySelector('[data-plan-variant]');
  var planProperty = root.querySelector('[data-plan-property]');
  var progressTitle = root.querySelector('[data-progress-title]');
  var progressCopy = root.querySelector('[data-progress-copy]');
  var progressBar = root.querySelector('[data-progress-bar]');
  var submitSummary = root.querySelector('[data-submit-summary]');
  var submitButton = root.querySelector('[data-submit-button]');
  var form = root.querySelector('.wd-subscription-form');
  var error = root.querySelector('[data-plan-error]');
  var activeSlots = 4;

  var today = new Date();
  today.setHours(0, 0, 0, 0);
  var finalDate = new Date(today);
  finalDate.setDate(finalDate.getDate() + 30);

  function dateValue(date) {
    var year = date.getFullYear();
    var month = String(date.getMonth() + 1).padStart(2, '0');
    var day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  root.querySelectorAll('[data-slot-date]').forEach(function(input) {
    input.min = dateValue(today);
    input.max = dateValue(finalDate);
    input.addEventListener('change', function() {
      if (!input.value) {
        input.setCustomValidity('');
        updateProgress();
        return;
      }
      var chosen = new Date(input.value + 'T00:00:00');
      if (chosen.getDay() === 1) {
        input.setCustomValidity('Monday delivery is unavailable. Please choose another date.');
        input.reportValidity();
      } else {
        input.setCustomValidity('');
      }
      updateProgress();
    });
  });

  function updateProgress() {
    var complete = 0;
    slots.slice(0, activeSlots).forEach(function(slot) {
      var loaf = slot.querySelector('[data-slot-loaf]');
      var date = slot.querySelector('[data-slot-date]');
      var preparation = slot.querySelector('[data-slot-preparation]');
      if (loaf.value && preparation.value && date.value && date.checkValidity()) complete += 1;
    });
    progressCopy.textContent = complete + ' of ' + activeSlots + ' deliveries complete';
    progressBar.style.width = ((complete / activeSlots) * 100) + '%';
  }

  function activatePlan(button) {
    activeSlots = Number(button.dataset.slots);
    planButtons.forEach(function(option) {
      var selected = option === button;
      option.classList.toggle('is-active', selected);
      option.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    variantInput.value = button.dataset.variant;
    planProperty.value = button.dataset.planName;
    progressTitle.textContent = 'Plan your ' + activeSlots + ' deliveries';
    submitSummary.textContent = activeSlots + ' loaves · ' + button.dataset.price;
    submitButton.textContent = 'Add plan to basket · ' + button.dataset.price;

    slots.forEach(function(slot, index) {
      var enabled = index < activeSlots;
      slot.hidden = !enabled;
      slot.querySelectorAll('select,input').forEach(function(field) {
        field.disabled = !enabled;
        field.required = enabled;
        if (!enabled) {
          field.value = '';
          field.setCustomValidity('');
        }
      });
    });
    error.hidden = true;
    updateProgress();
  }

  planButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      activatePlan(button);
    });
  });

  root.querySelectorAll('[data-slot-loaf]').forEach(function(select) {
    select.addEventListener('change', updateProgress);
  });
  root.querySelectorAll('[data-slot-preparation]').forEach(function(select) {
    select.addEventListener('change', updateProgress);
  });

  form.addEventListener('submit', function(event) {
    error.hidden = true;
    var firstInvalid = null;
    slots.slice(0, activeSlots).some(function(slot) {
      var fields = Array.from(slot.querySelectorAll('select,input'));
      firstInvalid = fields.find(function(field) { return !field.checkValidity(); });
      return Boolean(firstInvalid);
    });
    var consent = root.querySelector('[data-plan-consent]');
    if (!firstInvalid && !consent.checkValidity()) firstInvalid = consent;

    if (firstInvalid) {
      event.preventDefault();
      error.textContent = 'Choose every loaf, whole-or-sliced preparation and valid delivery date, then confirm the 30-day plan.';
      error.hidden = false;
      firstInvalid.reportValidity();
      firstInvalid.focus();
    }
  });

  activatePlan(planButtons[0]);
}

document.querySelectorAll('[data-wd-subscription]').forEach(initializeWeirdoughSubscription);
document.addEventListener('shopify:section:load', function(event) {
  event.target.querySelectorAll('[data-wd-subscription]').forEach(initializeWeirdoughSubscription);
});

  } catch(e) { console.error(e); }
})();
})();
